import React, {useContext, useEffect} from 'react'
import "./home.css"
import Banner from './Banner/Banner'
import Category from './Category/Category'
import Promo from './Promo/Promo'
import Featured from './Featured/Featured'
import Bestsellers from './BestSellers/Bestsellers'
import Ads from "./Ads/Ads"
import News from './NewsAndUpdates/News'
import { fetchDataFromApi } from '../../utils/api'
import { Context } from '../../utils/context'

function Home() {

  const {categories, setCategories, products, setProducts} = useContext(Context)

  const getCategories = () => {
    fetchDataFromApi("/api/categories?populate=*").then((res) => {console.log(res); setCategories(res)});
  }

  const getProducts = () => {
    fetchDataFromApi("/api/products?populate=*").then((res) => {console.log(res); setProducts(res)});
  }
  useEffect(() => {
    getProducts();
    getCategories();
  }, []);


  return (
    <div>
      <Banner />
      <div className="home-main-content">
        <div className="layout">
          <Category categories={categories}/>
          <Featured products={products} title="FEATURED PRODUCTS"/>
          <Promo />
        </div>
      </div>
      <Bestsellers products={products}/>
      <Ads />
      <div className="home-main-content">
        <div className="layout">
            <News />
        </div>
      </div>
    </div>
  )
}

export default Home
  